import React, {useContext, useState} from 'react';
import Avatar                        from '@material-ui/core/Avatar';
import Button                        from '@material-ui/core/Button';
import CssBaseline                   from '@material-ui/core/CssBaseline';
import TextField                     from '@material-ui/core/TextField';
import FormControlLabel              from '@material-ui/core/FormControlLabel';
import Checkbox                      from '@material-ui/core/Checkbox';
import Link                          from '@material-ui/core/Link';
import Grid                          from '@material-ui/core/Grid';
import Box                           from '@material-ui/core/Box';
import LockOutlinedIcon              from '@material-ui/icons/LockOutlined';
import Typography                    from '@material-ui/core/Typography';
import {makeStyles}                  from '@material-ui/core/styles';
import Container                     from '@material-ui/core/Container';
import {UserContext}                 from '../contexts/UserContext';
import Alert                         from '@material-ui/lab/Alert';
import {withRouter}                  from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
    paper:  {
        marginTop:     theme.spacing(8),
        display:       'flex',
        flexDirection: 'column',
        alignItems:    'center',
    },
    avatar: {
        margin:          theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form:   {
        width:     '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

function SignIn(props) {
    const classes = useStyles();
    const userContext = useContext(UserContext);

    const [state, setState] = useState({
        email:    '',
        password: '',
    });

    const onChange = (e) => {
        setState({...state, [e.target.name]: e.target.value});
    };

    const onSubmit = (e) => {
        e.preventDefault();
        userContext.login(state);
    };



    return (
        <Container component="main" maxWidth="xs"> <CssBaseline/>
            <div className={classes.paper}>
                <Avatar className={classes.avatar}> <LockOutlinedIcon/> </Avatar>
                <Typography component="h1" variant="h5"> Sign in </Typography>
                <form onSubmit={onSubmit} className={classes.form} noValidate>
                    <TextField
                        value={state.email}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        onChange={onChange}
                    /> <TextField
                    value={state.password}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    onChange={onChange}
                />
                    <FormControlLabel
                        control={<Checkbox value="remember" color="primary"/>}
                        label="Remember me"
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}>
                        Sign In
                    </Button>

                    <Grid container>
                        <Grid item xs>
                            <Link href="#" variant="body2"> Forgot password? </Link>
                        </Grid>
                        <Grid item>

                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={8}>
                {userContext.message.text && <Alert variant="filled" severity={userContext.message.severity}>{userContext.message.text}</Alert>}
            </Box>
        </Container>
    );
}

export default withRouter(SignIn);